// Darby Solutions JavaScript
let ClassicEditor = require('@ckeditor/ckeditor5-build-classic');
import * as Darby from './alerts';

/*** Product ***/
(function() {
  // Variables
  // =========
  let initialized = false;

  // Methods
  // =======
  function init(){
    if (!initialized){
      initialized = true;
      getProducts();
    }
  }

  function toggleCategory() {
    let categoryButton = $(this);
    $('#category_list button.button').attr('class', 'button badge-pill badge-primary');
    categoryButton.attr('class', 'button badge-pill badge-success');
    getProducts();
  }

  function collapseAll(){
    $('.collapse').collapse('hide');
  }

  function getProducts(){
    let page = 1;
    let CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
    let categoryIds = $('#category_list button.badge-success').map(function(){
      return $(this).val();
    }).get();
    let productCard = $('#category_results').attr('data-product-card');
    $.ajax(
      {
        /* the route pointing to the post function */
        url: '/products/category_products',
        type: 'POST',
        /* send the csrf-token and the input to the controller */
        data: {
          _token: CSRF_TOKEN,
          category_ids: categoryIds,
          card: productCard,
          page: page,
        },
        dataType: 'json',
        /* remind that 'data' is the response of the AjaxController */
        success: function ( data, textStatus, jqXHR) {
          //console.log(jqXHR);
          $('#category_results').html(data.html);
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.log(textStatus);
          console.log(errorThrown);
          // console.log(jqXHR);
        }
      }
    );
  }

  function toggleModifier() {
    let modifierButton = $(this);
    let modifier = modifierButton.parent();
    let buttons = $(modifier).children('button');
    if (modifierButton.attr('class') === 'button badge-pill badge-secondary modifier-product') {
      if (parseInt(modifier.attr('data-max')) === 1) {
        buttons.attr('class', 'button badge-pill badge-secondary modifier-product');
      }
      if (buttons.filter('.badge-success').length < parseInt(modifier.attr('data-max'))) {
        modifierButton.attr('class', 'button badge-pill badge-success modifier-product');
      } else {
        Darby.alertModal(modifier.attr('data-max') + ' Max for this modifier. Look at other modifiers for more options.');
      }
    } else {
      modifierButton.attr('class', 'button badge-pill badge-secondary modifier-product');
    }
  }

  function getModifiers(productButton) {
    let data = {
      message: "",
      modifiers: new Array(),
    };
    let modifierGroups = $('#modifiers' + productButton.attr('data-product_id')).find('div.btn-group-toggle');
    $(modifierGroups).each(function () {
      let modifier = {
        modifier_id: $(this).attr('data-modifier'),
        selected: new Array(),
      }
      let selectedButtons = $(this).children('button.badge-success');
      if ($(selectedButtons).length < parseInt($(this).attr('data-min'))) {
        data.message += 'Need to select at leaset ' + $(this).attr('data-min') + ' from ' + $(this).attr('data-title') + '\n';
      }
      $(selectedButtons).each(function () {
        modifier.selected.push($(this).attr('data-product'));
      })
      data.modifiers.push(modifier);
    });
    if (data.message !== '') {
      Darby.alertModal(data.message);
    }
    // console.log(data);
    return data;
  }

  function addToOrder() {
    let productButton = $(this);
    let modifierObject = getModifiers(productButton);
    if (modifierObject.message === '') {
      let CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
      let productId = productButton.attr("data-product_id");
      let quantity = $('#quantity' + productId).val();
      $('#quantity' + productId).val('1');
      let notes = $('#notes' + productId).val();
      $('#notes' + productId).val('');
      $.ajax(
        {
          /* the route pointing to the post function */
          url: '/orders/add',
          type: 'POST',
          /* send the csrf-token and the input to the controller */
          data: {
            _token: CSRF_TOKEN,
            product_id: productId,
            quantity: quantity,
            notes: notes,
            modifiers: modifierObject.modifiers,
            requestUri: '/orders/add',
          },
          dataType: 'json',
          /* remind that 'data' is the response of the AjaxController */
          success: function (data, textStatus, jqXHR) {
            //console.log(jqXHR);
            if (data.status == 'error'){
              Darby.alertModal(data.message);
            } else {
              $('#order').html(data.order_html);
              $('#order_options').html(data.order_options_html);
              $('#order_footer').html(data.footer_html);
              $('.collapse').collapse('hide');
            }
          },
          error: function (jqXHR, textStatus, errorThrown) {
            window.location.href = "/login";
            console.log(textStatus);
            console.log(errorThrown);
          }
        }
      );
      if(document.getElementsByTagName('main')[0].id == "gen2"){
        // normalModal();
      } else {return}
    }

  }

  function deleteFromOrder() {
    let deleteProduct = $(this).attr('data-product_id');
    // console.log(deleteProduct);
    let CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
    $.ajax(
      {
        /* the route pointing to the post function */
        url: '/orderProducts/itemDelete',
        type: 'POST',
        /* send the csrf-token and the input to the controller */
        data: {
          _token: CSRF_TOKEN,
          orderProduct_id: deleteProduct,
          quantity: 1,
          // modifiers: modifierObject.modifiers,
        },
        dataType: 'json',
        /* remind that 'data' is the response of the AjaxController */
        success: function (data, textStatus, jqXHR) {
          //console.log(jqXHR);
          if (data.status == 'error'){
            Darby.alertModal(data.message);
          } else {
            $('#order').html(data.html);
            $('#total_price').html(data.total_price);
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          window.location.href = "/login";
          console.log(textStatus);
          console.log(errorThrown);
        }
      }
    ); // END AJAX
  }

  // Events
  // ======

  // Buttons are not on the screen when the page is loaded
  // so need to attach the event to something that is there when loaded.
  $('#category_list').on('click', 'button', toggleCategory);
  $('#category_results').on('click', 'button.pos-product', collapseAll);
  $('#category_results').on('click', 'button.order-product', collapseAll);
  $('#category_results').on('click', 'button.add-to-order', addToOrder);
  $('#category_results').on('click', 'button.modifier-product', toggleModifier);
  // For button on the page when loaded outside category_results
  $('button.add-to-order').on('click', addToOrder);
  $('button.modifier-product').on('click', toggleModifier);
  $('#order').on('click', 'span.del-from-order', deleteFromOrder);

  if ( $('#category_list').length ) {
    init();
  }

})();


/*** Searches ***/

(function() {
  // variables
  // =========
  let initialized = false;
  let xhr;

  // Methods
  // =======

  function init(){
    if (!initialized){
      initialized = true;
    }
  }

  function getContactInfo(searchString){
    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
    if(xhr && xhr.readyState != 4){ /* 4 is Done */
      xhr.abort();
    }
    xhr = $.ajax(
      {
        /* the route pointing to the post function */
        url: '/phones/search_contact',
        type: 'POST',
        /* send the csrf-token and the input to the controller */
        data: {
          _token: CSRF_TOKEN,
          search_string: searchString,
        },
        dataType: 'json',
        /* remind that 'data' is the response of the AjaxController */
        success: function ( data, textStatus, jqXHR) {
          //console.log(jqXHR);
          if (data.full_name) {
            $('#full_name').val(data.full_name);
          }
          if (data.email) {
            $('#email').val(data.email);
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.log(textStatus);
          console.log(errorThrown);
          // console.log(jqXHR);
        }
      }
    );
  }

  function getSearch(event){
    let CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
    let search_string = $(this).val();
    let results_type = $(this).data('results_type');
    let results_id = $(this).data('results_id');
    let all_results_null = $(this).data('all_results_null');
    if (search_string === '' && !all_results_null){
      $('#' + results_id).html('');
      return;
    }
    let model = $(this).data('model');
    let field_name = $(this).data('field_name');
    let page = $(this).data('page');
    let tag_ids = $("#tag_list button.badge-success").map(function(){
      return $(this).val();
    }).get();
    if(xhr && xhr.readyState != 4){ /* 4 is Done */
      xhr.abort();
    }
    xhr = $.ajax(
      {
        /* the route pointing to the post function */
        url: '/' + model + '/' + results_type,
        type: 'POST',
        /* send the csrf-token and the input to the controller */
        data: {
          _token: CSRF_TOKEN,
          search_string: search_string,
          field_name: field_name,
          tags: tag_ids,
          page: page,
        },
        dataType: 'json',
        /* remind that 'data' is the response of the AjaxController */
        success: function ( data, textStatus, jqXHR) {
          //console.log(jqXHR);
          $('#' + results_id).html(data.html);
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.log(textStatus);
          console.log(errorThrown);
          // console.log(jqXHR);
        }
      }
    );
  }

  function setUse(event) {
    const field = '#use_' + $(this).data('model');
    $(field).val($(this).data('model_id'));
  }

  // Events
  // ======
  const transferTicketForm = document.getElementById('transfer_ticket_form');
  if (transferTicketForm) {
    $('#display_number').keyup(function (event) {
      const numbers = $(this).val().replace(/[^0-9]/g, '');
      if (numbers.length > 9) {
        getContactInfo($(this).val());
      }
    });
  }

  $(document).on('click', '.set-use', setUse);

  $('.search').on('keydown', function (){$(this).data('page', 1)})
    .on('keyup', getSearch);

  $(document).on('click', '.pagination a', function (event) {
    event.preventDefault();
    let page = $(this).attr('href').split('page=')[1];
    $('.search').data('page', page)
      .trigger('keyup');
  });

  $('#tag_list button.badge').click(function () {
    if ($(this).attr('class') == 'badge badge-pill badge-secondary'){
      $(this).attr('class', 'badge badge-pill badge-success');
    } else {
      $(this).attr('class', 'badge badge-pill badge-secondary');
    }
    $('.search').data('page', 1)
      .trigger('keyup');
  });

  // Load initial results
  $('.search').each(function(index){

    if ($(this).data('results_type').indexOf('list') > 0 && $(this).val() != null){
      return;
    }
    $('.search').trigger('keyup');
  });

})();

/*** Events ***/

(function() {

  // variables
  // =========
  let initialized = false;

  // Methods
  // =======

  function init(){
    if (!initialized){
      initialized = true;
    }
  }

  function changeRole(event){
    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
    var entityEvent_id = $(this).attr("data-entityEvent_id");
    var role = $(this).text();
    $.ajax(
      {
        /* the route pointing to the post function */
        url: '/entityEvents/toggleRole',
        type: 'POST',
        /* send the csrf-token and the input to the controller */
        data: {
          _token: CSRF_TOKEN,
          entityEvent_id: entityEvent_id,
        },
        dataType: 'json',
        /* remind that 'data' is the response of the AjaxController */
        success: function ( data, textStatus, jqXHR) {
          $('#attendies').html(data.html);
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.log(textStatus);
          console.log(errorThrown);
        }
      }
    );
  }

  function formatPhoneNumber(event) {
    const phoneNumberString = $(this).val();
    const numbers = phoneNumberString.replace(/[^0-9]/g, '');
    let formattedNumber = phoneNumberString;
    // Do not format if first character is a space
    const lastCharacter = formattedNumber[formattedNumber.length - 1];
    if (formattedNumber[0] != ' '
      && lastCharacter != '-'
      && lastCharacter != ' '
      && lastCharacter != 'x') {
      if (numbers.length > 10){
        formattedNumber = numbers.slice(0,3) + '-' + numbers.slice(3,6) + '-' + numbers.slice(6,10) + ' x' + numbers.slice(10);
      } else if (numbers.length > 6){
        formattedNumber = numbers.slice(0,3) + '-' + numbers.slice(3,6) + '-' + numbers.slice(6,10);
      } else if (numbers.length > 3){
        formattedNumber = numbers.slice(0,3) + '-' + numbers.slice(3,6);
      } else {
        formattedNumber = numbers;
      }
    }
    $(this).val(formattedNumber);
  }

  // Events
  // ======

  $(document).on('click', '.change-role', changeRole);
  $(document).on('keyup', '#display_number', formatPhoneNumber);

  // Set up notifications
  window.Echo.channel('darby-events')
    .listen('ChangeRole', changeRole => {
      console.log('ChangeRole notice for event received.');
      console.log(changeRole);
      let entityButton = $('#attendies button[data-entityevent_id = ' + changeRole.entity_event.id + ']');
      entityButton.removeClass('badge-primary');
      entityButton.removeClass('badge-success');
      entityButton.removeClass('badge-light');
      switch (changeRole.entity_event.entity_role) {
        case 'Attendant':
          entityButton.addClass('badge-primary');
          break;
        case 'Participant':
          entityButton.addClass('badge-success');
          break;
        case 'Absent':
          entityButton.addClass('badge-light');
          break;
        default:
          entityButton.addClass('badge-light');
      }
    })
  ;

  // automatic alertModals
  $('.alertModal').each(function(index){
    Darby.alertModal($(this).text());
  });

  $('#dialog').each(function(index){
    Darby.testModal();
  });

})();

// CK Editor - Size is set via style
$('.ckeditor').each(function(index) {
  ClassicEditor
    .create(this)
    .then(editor => {
      console.log(editor);
    })
    .catch(error => {
      console.error(error);
    });
});

// jQuery UI calendar
$( "#birthday" ).datepicker({
  dateFormat: "yy-mm-dd",
  changeMonth: true,
  changeYear: true,
  defaultDate: "-35y",
  maxDate: "-1",
  yearRange: "-100:+1"
});



